import styled from 'styled-components'

export const LessonEl = styled.div`
  display: block;
  width: 100%;
  height: calc(100vh - 5em);

  @media (max-device-width: 1366px) {
    font-size: 0.9em;
  }
`

export const ContentEl = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 2.5em 40em 2.5em 10em;
  overflow: auto;
`
